import React, { useState, useEffect } from 'react';
import {PlusOutlined, UploadOutlined} from '@ant-design/icons';
import {Button, Col, Drawer, Form, Input, Row, Space, Table, Upload} from 'antd';
import { ApiApartmentBuilderService } from '../../../../../shared/api/apartment/builder/builder.service';
import { countText, SectionToolbar, useSectionSearch } from '../../components/SectionToolbar/SectionToolbar';
import { useCanEdit } from '../../../sectionAccess';

const inputs = [
  {key: 'name', placeholder: "Введите название застройщика"},
  {key: 'sameType', placeholder: "Варианты написания через запятую, например: Сетл, Setl (по ним ищут на портале)"}
]

const initialBuilderInfo = {
  name: '',
  sameType: '',
}

export const BuilderSection = () => {
  const canEdit = useCanEdit();
  const [buildersList, setBuildersList] = useState([])
  const [builderInfo, setBuilderInfo] = useState({...initialBuilderInfo})
  const [isOpenedDrawer, setIsOpenedDrawer] = useState(false)
  const [builderFile, setBuilderFile] = useState([])
  const [editableBuilderId, setEditableBuilderId] = useState(null)
  const [search, setSearch, builders] = useSectionSearch(buildersList, ['name', 'sameType', 'id'])

  const createFormData = () => {
    let formData = new FormData()
    inputs.map(({key}) => formData.append(key, builderInfo[key]))

    builderFile[0]?.originFileObj
      ? formData.append('file', builderFile[0].originFileObj)
      : formData.append('file', '')

    return formData
  }

  const submitNewBuilder = async () => {
    let formData = createFormData()

    try {
      editableBuilderId
        ? await ApiApartmentBuilderService.updateBuilder(editableBuilderId, formData)
        : await ApiApartmentBuilderService.createBuilder(formData)

      alert(`Застройщик успешно ${editableBuilderId ? 'изменен' : 'создан'}`)
      setTimeout(() => setIsOpenedDrawer(false), 500)
      fetchBuilders()

    } catch (err) {
      alert('Упс, произошла ошибка')
      setTimeout(() => setIsOpenedDrawer(false), 500)
    }

  };


  const handleBuilderFile = (info) => {
    let fileList = [...info.fileList];
    setBuilderFile(fileList);
  }

  const fetchBuilders = () => {
    ApiApartmentBuilderService.fetchBuilders().then(response => {
      setBuildersList(response?.data)
    });
  }

  const fetchBuilderFile = (id) => {
    ApiApartmentBuilderService.getBuilderFile(id).then(res => {
      if (res?.data?.filename) {
        setBuilderFile([{name: res.data.filename}])
      }
    })
  }

  useEffect(() => {
    fetchBuilders()
  }, []);

  const handleCloseDrawer = () => {
    setIsOpenedDrawer(false)
    setBuilderFile([])
    setBuilderInfo({...initialBuilderInfo})
    setEditableBuilderId(null)
  }

  const setEditableBuilder = (id) => {
    const editableBuilder = buildersList.find(item => item.id === id)
    let builder
    Object.keys(editableBuilder).forEach(key => {
      if (key in initialBuilderInfo && editableBuilder[key]) {
        builder = {...builder, [key]: editableBuilder[key]}
      }
    })
    setBuilderInfo(builder)
    fetchBuilderFile(id)
  }

  const buildersTableColumn = [
    { title: 'ID', dataIndex: 'id', width: 90 },
    {
      title: 'Застройщик',
      key: 'name',
      render: ({ name, sameType }) => (
        <>
          <div>{name}</div>
          {sameType && <div className='cell-hint'>{sameType}</div>}
        </>
      ),
    },
    canEdit && {
      title: 'Действия',
      key: 'actions',
      width: 260,
      render: ({ id, name }) => (
        <Space size="small">
          <Button
            onClick={() => {
              setEditableBuilderId(id)
              setEditableBuilder(id)
              setIsOpenedDrawer(true)
            }}
          >
            Изменить
          </Button>
          <Button
            danger
            onClick={() => {
              let isAgree = window.confirm(`Вы уверены что хотите удалить застройщика ${name}?`)
              if (isAgree) {
                ApiApartmentBuilderService.deleteBuilder(id).then(() => fetchBuilders())
              }
            }}
          >
            Удалить
          </Button>
        </Space>
      ),
    },
  ].filter(Boolean);

  return (
    <section className="builder-section">
      <Table
        title={() => (
          <SectionToolbar
            search={search}
            onSearch={setSearch}
            placeholder='Название застройщика или ID'
            count={countText(buildersList.length, builders.length, search)}
          >
            {canEdit && (
              <Button type="primary" icon={<PlusOutlined />} onClick={() => setIsOpenedDrawer(true)}>
                Добавить застройщика
              </Button>
            )}
          </SectionToolbar>
        )}
        columns={buildersTableColumn}
        dataSource={builders}
        rowKey="id"
        locale={{ emptyText: 'Ничего не нашлось' }}
      />
      <Drawer
        title={`${editableBuilderId ? "Изменить" : "Создать"} застройщика`}
        width={720}
        onClose={handleCloseDrawer}
        visible={isOpenedDrawer}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: 'right',
            }}
          >
            <Button onClick={() => setIsOpenedDrawer(false)} style={{ marginRight: 8 }}>
              Отменить
            </Button>
            <Button onClick={submitNewBuilder} type="primary">
              {editableBuilderId ? "Изменить" : "Создать"}
            </Button>
          </div>
        }
      >
        <Form layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={24}>

              {inputs.map( ({ key, placeholder}) => (
                <Input
                  key={key}
                  onChange={(e) => setBuilderInfo({...builderInfo, [key]: e.target.value})}
                  placeholder={placeholder}
                  value={builderInfo[key]}
                  style={{marginBottom: "10px"}}
                />
              ))}

              <Upload
                name="file"
                accept=".pdf"
                beforeUpload={() => false}
                fileList={builderFile}
                onChange={handleBuilderFile}
                maxCount={1}
              >
                <Button icon={<UploadOutlined />}>Добавить буклет застройщика</Button>
              </Upload>

            </Col>
          </Row>
        </Form>
      </Drawer>

    </section>
  );
};
